<script lang=ts>
    import Select from "svelte-select";
    import { FormGroup, Label } from "sveltestrap";
    import { Category, Content } from "../../../../utils/Constant/Constant";
    let items = [
      { value: "lifestyle", label: "Life Style" },
      { value: "Travel", label: "Travel" },
    ];
</script>
  
<FormGroup>
    <div class="col-form-label">
      {Category}:
      <Select {items} multiple />
    </div>
</FormGroup>
<div class="email-wrapper">
    <div class="theme-form">
      <FormGroup>
        <Label>{Content}</Label>
        <textarea id="text-box" name="text-box" rows="4" />
      </FormGroup>
    </div>
</div>
  